import React from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { FaPlus, FaGamepad } from "react-icons/fa";
import { getMyGames } from "../../api/game";
import GameCard from "../../components/cards/GameCard";
import { useSubscription } from "../../contexts/SubscriptionContext";
import { queueEvent } from "../../analytics";
import { EVENTS } from "../../analytics/events";
import { Button, Card, PageSpinner } from "../../ui";

const GamesList = () => {
  const navigate = useNavigate();
  const { limit, isLimitReached, showUpgradeModal } = useSubscription();

  const { data: games, isLoading } = useQuery({
    queryKey: ["myGames"],
    queryFn: getMyGames,
  });

  const gamesCount = games?.length || 0;
  const maxGames = limit("MAX_GAMES");
  // Match the app: newest game first (backend returns insertion order).
  const sortedGames = [...(games || [])].sort(
    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
  );

  const handleCreate = () => {
    queueEvent(
      gamesCount === 0
        ? EVENTS.GAME_CREATE_FIRST_PRESSED
        : EVENTS.GAME_CREATE_PRESSED,
      { count: gamesCount },
    );
    if (isLimitReached("MAX_GAMES", gamesCount)) {
      queueEvent(EVENTS.GAME_CAP_REACHED, {
        count: gamesCount,
        limit: maxGames === Infinity ? -1 : maxGames,
      });
      showUpgradeModal({ messageKey: "GAMES_LIMIT" });
      return;
    }
    navigate("/app/games/create");
  };

  return (
    <div>
      <div className="flex flex-wrap items-end justify-between gap-4 mb-6 md:mb-8">
        <div>
          <h1 className="text-2xl md:text-3xl font-extrabold">ألعابي</h1>
          {maxGames !== Infinity && (
            <p className="text-white/55 text-sm mt-1">
              استخدمت {gamesCount} من {maxGames} ألعاب
            </p>
          )}
        </div>
        <Button onClick={handleCreate} icon={<FaPlus aria-hidden="true" />}>
          إنشاء لعبة
        </Button>
      </div>

      {isLoading ? (
        <PageSpinner />
      ) : gamesCount === 0 ? (
        <Card pad="lg" className="text-center py-14 md:py-16">
          <span className="mx-auto mb-4 w-16 h-16 rounded-2xl bg-white/10 text-primary flex items-center justify-center">
            <FaGamepad size={30} aria-hidden="true" />
          </span>
          <p className="text-lg font-bold">لا توجد ألعاب بعد</p>
          <p className="text-white/55 text-sm mt-1 mb-6">
            اختر الفئات والفِرَق، وابدأ اللعب من هنا.
          </p>
          <Button onClick={handleCreate} icon={<FaPlus aria-hidden="true" />}>
            أنشئ أول لعبة
          </Button>
        </Card>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {sortedGames.map((game) => (
            <GameCard
              key={game._id}
              game={game}
              onClick={() => navigate(`/app/games/${game._id}`)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default GamesList;
